import { render, staticRenderFns } from "./my-agents.vue?vue&type=template&id=5da706d6&scoped=true"
import script from "./my-agents.vue?vue&type=script&lang=js"
export * from "./my-agents.vue?vue&type=script&lang=js"
import style0 from "./my-agents.vue?vue&type=style&index=0&id=5da706d6&prod&lang=scss&scoped=true"
import style1 from "./my-agents.vue?vue&type=style&index=1&id=5da706d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da706d6",
  null
  
)

export default component.exports